import React from 'react';
import { TermsAndConditions } from '../../../CommonComponents/TermsAndCondition';
const TermsConditionsPage = () => {
  return (
    <main>
      <TermsAndConditions />
    </main>
  );
};

export default TermsConditionsPage;
